/* Ten Antennas — colour dots inside variant pills.
   Loaded from snippets/meta-tags.liquid. Runs on any page that renders a
   variant picker, so it covers the fullscreen PDP and the quick-add modal.

   The colour lookup mirrors the one in snippets/card-product.liquid — keep
   the two in sync when a new stone name enters the catalogue. */
(function () {
  var MAP = [
    ['acid', '#A7FF37'],
    ['peridot', '#B9C94E'],
    ['green', '#6FA84B'],
    ['pink', '#E3A7B5'],
    ['rose', '#E3A7B5'],
    ['sky blue', '#A6C4E4'],
    ['blue', '#A6C4E4'],
    ['topaz', '#A6C4E4'],
    ['aqua', '#A6C4E4'],
    ['purple', '#9B7FBF'],
    ['amethyst', '#9B7FBF'],
    ['violet', '#9B7FBF'],
    ['citrin', '#E6C548'],
    ['yellow', '#E6C548'],
    ['amber', '#C6791F'],
    ['red', '#A32E2E'],
    ['ruby', '#A32E2E'],
    ['garnet', '#A32E2E'],
    ['black', '#1A1A1A'],
    ['onyx', '#1A1A1A'],
    ['cream', '#F0E6D2'],
    ['pearl', '#EDE6DA'],
    ['champagne', '#E5D3B3'],
    ['smoky', '#7A6A60'],
    ['gold', '#C9A96A'],
    ['snow', '#F4F4F4'],
    ['white', '#F4F4F4'],
    ['crystal', '#F0F0F0'],
    ['clear', '#F0F0F0'],
    ['zirconia', '#F0F0F0']
  ];

  function hexFor(text) {
    var t = (text || '').toLowerCase();
    for (var i = 0; i < MAP.length; i++) {
      if (t.indexOf(MAP[i][0]) !== -1) return MAP[i][1];
    }
    return null;
  }

  function decorate(root) {
    var pickers = (root || document).querySelectorAll('variant-radios, variant-selects');
    pickers.forEach(function (picker) {
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend || !/colou?r/i.test(legend.textContent)) return;

        fs.querySelectorAll('label').forEach(function (label) {
          if (label.dataset.taSwatched) return;
          var hex = hexFor(label.textContent);
          if (!hex) return;
          label.dataset.taSwatched = '1';
          var dot = document.createElement('span');
          dot.className = 'ta-pill-dot';
          dot.style.background = hex;
          label.insertBefore(dot, label.firstChild);
        });
      });
    });
  }

  function boot() { decorate(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Dawn re-renders the variant picker after every selection, which wipes the
     dots — re-run whenever the section markup is replaced. */
  document.addEventListener('change', function () {
    setTimeout(boot, 60);
  });

  var mo = new MutationObserver(function () { boot(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
